import { createContext } from "react";
import { AwsChatterEntryModel } from "../models/awsDataModel";

export const ChatterAlertsContext = createContext<AwsChatterEntryModel[]>([]);
